

function useAuthCalls() {

    async function call(func, onSuccess, onFailure) {
        try {
            let response = await func();
            if (response) {
                if(response.data) {
                    response = response.data ?? response;
                    const status = response.status;
                    const data = response.data ?? response;
                    if(status === "ok") {
                        if(onSuccess) {
                            return await onSuccess(data);
                        }
                    }

                    if(status === "ko") {
                        //TODO: show error message
                        if(onFailure) {
                            return await onFailure(data);
                        }
                    }
                }
                return onSuccess(response);
            }

            onFailure && await onFailure(response);
        } catch (error) {
            onFailure && await onFailure(error);
        }
    }

    return {
        call,
    }
}

export default useAuthCalls;